

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import deleteIcon from './images/delete-icon.svg';

function SortingCallsLabel(props) {
const [sortObject, setSortObject] = useState({});

useEffect(() => {
  setSortObject(getLabelText());
}, [props.selectedSort]);

  const getLabelText = () => {
    let sortObject = {};
    switch (props.selectedSort.sortName) {
      case 'date':
        sortObject.title = 'תאריך';
        sortObject.sortType = props.selectedSort.sortType == 'desc' ? 'מחדש לישן' : 'מישן לחדש';
        break;
      case 'operator':
        sortObject.title = 'שם המפעיל';
        sortObject.sortType = props.selectedSort.sortType == 'desc' ? 'א\'-ת\'' : 'ת\'-א\'';
        break;
      case 'duration':
        sortObject.title = 'כמות שנצרכה';
        sortObject.sortType = props.selectedSort.sortType == 'desc' ? 'מגבוה לנמוך' : 'מנמוך לגבוה';
        break;
      case 'subscriberNumber':
        sortObject.title = 'מספר שחוייג';
        sortObject.sortType = props.selectedSort.sortType == 'desc' ? 'מספר עולה ליורד' : 'מספר יורד לעולה';
        break;
      case 'price':
        sortObject.title = 'סכום';
        sortObject.sortType = props.selectedSort.sortType == 'desc' ? 'מגבוה לנמוך' : 'מנמוך לגבוה';
        break;
    }
    return sortObject;
  }


  return (
    <div className='sorting-calls-label' >
        <h2>מיון לפי</h2>
        <div className='sort-label-item'>
            <button className='remove-sort-btn' onClick={() => props.onClickRemoveSort(true)} style={{backgroundImage:deleteIcon.bg()}}/>
            <span>{sortObject.title}:</span>
            <span>{sortObject.sortType}</span>
        </div>
    </div>
  );
}



const mapStateToProps = (state) => {
  return {

  };
};
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SortingCallsLabel);
